

export const trayDialogEvent = ({ data: { type } } = {}) => {
    if (["tray.authpopup.error", "tray.configPopup.error"].includes(type))
        return "error"
    else if (["tray.authpopup.cancel", "tray.configPopup.cancel"].includes(type))
        return "cancel"
    else if (["tray.authpopup.ready", "tray.configPopup.ready"].includes(type))
        return "ready"
    else if (["tray.authpopup.close", "tray.configPopup.close"].includes(type))
        return "close"
    else if (["tray.authpopup.finish", "tray.configPopup.finish"].includes(type))
        return "finish"
    else
        return "error"
}